<template>
  <v-row>
    <v-col class="d-flex" md="6" >
      <custom-search
        ref="customSearch"
        title="Postal Code Filter"
        subtitle="Filter customers having these Postal Codes"
        v-model="postal_codes"
        item-text="desc"
        item-value="postal_code"
        :search-fn="postalCodeSearchFn()"
      >
        <template v-slot:toolbar>
          <v-card-text>
            <v-text-field 
              v-model="manualPostalCodes" 
              placeholder="Enter postal code(s) - comma separated for multiple"
              @keyup.enter="addManualPostalCodes"
            ></v-text-field>
            <v-btn @click="addManualPostalCodes" color="primary">Add Postal Code(s)</v-btn>
            <p v-show="manualEntryError" class="red--text">{{ manualEntryError }}</p>
          </v-card-text>
        </template>
      </custom-search>
    </v-col>
  </v-row>
</template>

<script>
import validationMixin from '@/validators/validations_mixin'
import CustomSearch from './CustomSearch'
import { PostalCodesApi } from '@/services'

export default {
  name: 'postal-code-search',
  inputType: 'postal_code_search',
  components: {
    [CustomSearch.name]: CustomSearch
  },
  mixins: [validationMixin],
  props: {
    value: {
      type: Object,
      require: true
    },
    paramName: {
      type: String,
      require: true
    },
    modelValue: {
      type: Object,
      require: true
    },
    errorMessages: {
      type: Array
    }
  },
  data: function () {
    return {
      manualPostalCodes: '',
      manualEntryError: null
    }
  },
  computed: {
    postal_codes: {
      get () {
        // if postal_codes has no value, send an empty array as value for the initial default setting
        if (!this.modelValue.postal_codes) {
          this.$emit('update-query-param-value', { name: this.paramName, key: 'postal_codes', value: [] })
          return []
        } else {
          return this.modelValue.postal_codes
        }
      },
      set (val) {
        this.$emit('update-query-param-value', { name: this.paramName, key: 'postal_codes', value: val })
      }
    }
  },
  methods: {
    postalCodeSearchFn () {
      return async function (searchTerm) {
        const resp = await PostalCodesApi.search(searchTerm)
        return resp.data.map(postalCode => { return { postal_code: postalCode.postal_code, desc: `${postalCode.city}, ${postalCode.state}` } })
      }
    },
    addManualPostalCodes () {
      if (!this.manualPostalCodes) {
        this.manualEntryError = 'Please enter at least one postal code'
        return
      }
      
      // Split by comma and clean up each postal code
      const postalCodes = this.manualPostalCodes
        .split(',')
        .map(code => code.trim())
        .filter(code => code.length > 0)
      
      if (postalCodes.length === 0) {
        this.manualEntryError = 'Please enter at least one valid postal code'
        return
      }
      
      // Validate postal codes (5 digits)
      const invalidCodes = postalCodes.filter(code => !/^\d{5}$/.test(code))
      if (invalidCodes.length > 0) {
        this.manualEntryError = `Invalid postal code(s): ${invalidCodes.join(', ')}. Postal codes must be 5 digits.`
        return
      }
      
      // Get current postal codes to avoid duplicates
      const currentPostalCodes = this.postal_codes.map(pc => pc.postal_code)
      
      // Add new postal codes that aren't already in the list
      const newPostalCodes = postalCodes
        .filter(code => !currentPostalCodes.includes(code))
        .map(code => ({
          postal_code: code,
          desc: 'Manually Added'
        }))
      
      if (newPostalCodes.length > 0) {
        // Add to existing postal codes
        this.$emit('update-query-param-value', {
          name: this.paramName,
          key: 'postal_codes',
          value: [...this.postal_codes, ...newPostalCodes]
        })
        
        // Clear the input
        this.manualPostalCodes = ''
        this.manualEntryError = null
      } else {
        this.manualEntryError = 'All entered postal codes are already in the list'
      }
    }
  }
}
</script>
